module.exports = "https://static.im-cdn.com/mjc/storefront/Ikkat/static/media/DefaultProductImage.866052c2.png";